// A static import-map dependency lets the compatibility loader replay this
// graph and rewrite its dynamic imports on browsers without import-map support.
import '@theme/component';

const manifest = document.getElementById('conditional-component-assets');

if (manifest) {
  const assets = JSON.parse(manifest.textContent);
  const pending = new Map();
  const loaded = new Set();

  const load = (name) => {
    if (pending.has(name)) return pending.get(name);
    const asset = assets[name];
    const request = Promise.all((asset.dependencies ?? []).map(load))
      .then(() => import(asset.url))
      .then(() => {
        loaded.add(name);
        if (loaded.size === Object.keys(assets).length) observer.disconnect();
      });
    pending.set(name, request);
    return request;
  };

  const scan = (root) => {
    const remaining = Object.entries(assets).filter(([name]) => !pending.has(name));
    if (!remaining.length) return;
    const selector = remaining.map(([, asset]) => asset.selector).join(',');
    const matches = [...root.querySelectorAll(selector)];
    if (root instanceof Element && root.matches(selector)) matches.push(root);
    for (const [name, asset] of remaining) {
      if (pending.has(name) || !matches.some((element) => element.matches(asset.selector))) continue;
      load(name).catch((error) => console.error(`Unable to load theme component ${name}`, error));
    }
  };

  // Covers section rendering, quick-add content and editor additions without
  // rescanning the whole document for every form or app mutation.
  const observer = new MutationObserver((records) => {
    for (const record of records) {
      for (const node of record.addedNodes) {
        if (node instanceof Element && node.isConnected) scan(node);
      }
    }
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });
  scan(document);
}
